// Catalog card data. Mirrors the client's CardData shape (client/src/game/objects/CardSprite.ts)
// so the same card definitions can be shared between client renderer and server engine.
export interface CardData {
  id: string;
  name: string;
  type: string;
  level?: number;
  typeline?: string[];
  humanReadableCardType?: string;
  desc?: string;
  atk?: number;
  def?: number;
  race?: string;
  attribute?: string;
  archetype?: string;
  /** House print rarity for this copy. Catalog rows omit it. */
  foil?: string;
}

/** Coarse card category derived from the catalog `type` string. */
export enum CardKind {
  MONSTER = 'MONSTER',
  SPELL = 'SPELL',
  TRAP = 'TRAP',
}

export function getCardKind(card: CardData): CardKind {
  const type = (card.type || '').toLowerCase();
  if (type.includes('trap')) return CardKind.TRAP;
  if (type.includes('spell') || type.includes('magic')) return CardKind.SPELL;
  return CardKind.MONSTER;
}

export function isMonster(card: CardData): boolean {
  return getCardKind(card) === CardKind.MONSTER;
}

export function isSpell(card: CardData): boolean {
  return getCardKind(card) === CardKind.SPELL;
}

export function isTrap(card: CardData): boolean {
  return getCardKind(card) === CardKind.TRAP;
}

/**
 * Fusion (and later Extra) monsters. They may never sit in the Main Deck or
 * be Normal/Tribute Summoned from hand — only Fusion Summoned from Extra.
 */
export function isExtraDeckCard(card: {
  type?: string;
  typeline?: string[];
  humanReadableCardType?: string;
  frameType?: string;
}): boolean {
  if (card.frameType === 'fusion') return true;
  if (card.typeline?.some((t) => t.toLowerCase() === 'fusion')) return true;
  const blob = `${card.type ?? ''} ${card.humanReadableCardType ?? ''}`.toLowerCase();
  return blob.includes('fusion');
}
